import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import TranscriptSegment from './TranscriptSegment';

function TranscriptParagraph({
  segments,
  isActive,
  activeSegment,
  activeWord,
  onTimestampClick,
  onWordClick,
  elementRef
}) {
  return (
    <Box
      ref={elementRef}
      sx={{
        px: { xs: 0.5, sm: 1 },
        py: { xs: 1, sm: 1.25 },
        mb: { xs: 1.5, sm: 2 },
        borderRadius: 1,
        bgcolor: isActive ? 'action.selected' : 'transparent',
        transition: 'background-color 0.2s',
        contentVisibility: 'auto',
        containIntrinsicSize: '100px'
      }}
    >
      <Typography
        variant="body1"
        component="p"
        sx={{
          textAlign: 'left',
          lineHeight: { xs: 1.8, sm: 1.75 },
          wordWrap: 'break-word',
          overflowWrap: 'anywhere'
        }}
      >
        {segments.map((segment) => (
          <TranscriptSegment
            key={`${segment.start}-${segment.end}`}
            segment={segment}
            isActive={isActive && activeSegment?.start === segment.start}
            activeWord={isActive ? activeWord : null}
            onTimestampClick={onTimestampClick}
            onWordClick={onWordClick}
          />
        ))}
      </Typography>
    </Box>
  );
}

export default memo(TranscriptParagraph);
